import { QueryClientProvider } from '@tanstack/react-query';

import { ConfirmProvider } from '@/components/common';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { queryClient } from '@/lib/queryClient';

/** 앱 전역 프로바이더 — Query · Tooltip · Confirm · Toaster(우상단, 헤더 아래). */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={200}>
        <ConfirmProvider>{children}</ConfirmProvider>
      </TooltipProvider>
      <Toaster position="top-right" offset={{ top: 78 }} closeButton />
    </QueryClientProvider>
  );
}
